import { render, staticRenderFns } from "./SetDeliveryConfig.vue?vue&type=template&id=4e0e522a&"
import script from "./SetDeliveryConfig.vue?vue&type=script&lang=ts&"
export * from "./SetDeliveryConfig.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports